(() => {
  document.querySelectorAll('[data-dec-inquiry-context]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const source = root.querySelector('[data-inquiry-source]');
    source.value = location.origin + location.pathname;
    const region = root.querySelector('[data-inquiry-region]');
    const consent = root.querySelector('[data-inquiry-consent]');
    const status = root.querySelector('[data-inquiry-status]');
    let result, pending, version = 0;
    consent.addEventListener('change', async () => {
      const current = ++version;
      if (!consent.checked) { region.value = 'Not shared'; status.textContent = ''; return; }
      region.value = 'Unavailable (lookup pending)';
      status.textContent = 'Checking approximate region… You can still submit your enquiry.';
      if (!pending) {
        pending = (async () => {
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 3500);
          try {
            const response = await fetch('https://api.ipapi.is/', {signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer'});
            if (!response.ok) throw new Error('Region unavailable');
            const data = await response.json();
            const locationData = data.location || data;
            const parts = [locationData.country, locationData.state || locationData.region].filter(x => typeof x === 'string' && x.trim()).map(x => x.slice(0,100));
            result = parts.length ? parts.join(' / ') + ' (IP estimate; may reflect VPN/network location)' : 'Unavailable';
          } catch (_) { result = 'Unavailable'; }
          finally { clearTimeout(timeout); }
        })();
      }
      await pending;
      if (current !== version || !consent.checked) return;
      region.value = result;
      status.textContent = result === 'Unavailable' ? 'Region could not be determined. You can still send your enquiry.' : 'Approximate region included. Your delivery address may be different.';
    });
  });
})();
